import { GEO_ZONE_LOCATION_EXCLUSION_INITIAL_STATE } from 'components/common/geo-zone-location/geoZoneLocationExclusion'

export const INITIAL_STATE = {
  zones: GEO_ZONE_LOCATION_EXCLUSION_INITIAL_STATE,
  address: {
    addressName: '',
    line1: '',
    unitNumber: '',
    city: '',
    state: '',
    country: '',
    zipCode: '',
    latitude: '',
    longitude: '',
  },
  contacts: [],
  tags: [],
  serviceAfter: '',
  serviceBefore: '',
  serviceAppliesOnDays: [],
  signatureRequired: false,
  locationPurchaseOrder: false,
  po: '',
  maxPoAmount: '',
  parcelNumber: '',
}
